// extracted by mini-css-extract-plugin
export default {"wrapper":"toggle__wrapper__UVDn4","label":"toggle__label__smZux","input":"toggle__input__aRBbp","dark":"toggle__dark__GWUDn","small":"toggle__small__qmont"};